import React, { useState, useEffect } from 'react'
import { Alert } from "@mui/material";
import Select from "react-select";
import { baseURL } from '../backend_url';
import { Button } from '@mui/material'
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import EditIcon from '@mui/icons-material/Edit';
import Swal from 'sweetalert2';
import axios from 'axios';

export default function UpdateForm() {
    const removeSpaces = (val) => {
        let temp = '';
        for (let i = 0; i < val.length; i++) {
            if (val[i] !== ' ') {
                temp += val[i];
            }
        }
        return temp;
    }

    const [companyDetail, setcompanyDetail] = useState([{}]);
    const [companyName, setCompanyName] = useState("Routes Car Rental");
    const [company_id, setcompany_id] = useState("690337");

    const [createNewFlag, setCreateNewFlag] = useState(false);

    const [roleName, setRoleName] = useState('');
    const [showFor, setShowFor] = useState('');

    const [modulesList, setModuleList] = useState([]);
    const columnList = ["Access Specifier"];
    const [grid, setGrid] = useState({});

    const [listOfRoles, setListOfRoles] = useState([]);

    const [editFlag, setEditFlag] = useState(false);

    const [validationMsg, setValidationMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const [role_id, setRole_id] = useState("");
    const [loggedInUserDetail, setLoggedInUserDetail] = useState({});

    // form validation rules 
    const validationSchema = Yup.object().shape({
        roleName: Yup.string()
            .required('Required')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, setValue, formState: { errors } } = useForm(formOptions);

    //API call
    useEffect(() => {

        const loggedInUser = sessionStorage.getItem("user_token");
        const foundUser = JSON.parse(loggedInUser);
        setLoggedInUserDetail(foundUser);

        axios.get(baseURL + "/get_company_details_for_users")
            .then((res1) => {

                fetch(baseURL + "/get_srt_modules")
                    .then((res) => res.json())
                    .then((data) => {
                        setModuleList(data);
                        res1.data.unshift({'company_name': 'Admin', '_id': 'Admin'})
                        setcompanyDetail(res1.data);

                        // initial values of the grid
                        let hmap = {}
                        for (let i = 0; i < data.length; i++) {
                            for (let j = 0; j < columnList.length; j++) {
                                let module_name = removeSpaces(data[i]['name']);
                                let col_name = columnList[j];

                                let key = module_name + "_" + col_name;
                                hmap[key] = '';

                                if (col_name === 'Access Specifier') {
                                    hmap[key] = accessSpecifierOptions[0]['value'];
                                }

                            }
                        }

                        setGrid(hmap);
                    });
            });

        setRoleName('');
        setShowFor('');
        resetHmapValues();

        // Yup Validation setValue
        // setting value for Yup validations
        setValue('roleName', '');

        setEditFlag(false);
    }, []);

    //Option for company name
    const companyNameOptions = companyDetail.map((value) => (

        { value: value.company_name, label: value.company_name, _id: value._id }
    ));

    const handleInputChangeCompanyName = characterEntered => {
        setCompanyName(characterEntered.value);
        setcompany_id(characterEntered._id);
    };


    useEffect(() => {

        fetch(baseURL + "/get_srt_roles_setup_data/" + company_id.toString())
            .then((res) => res.json())
            .then((data) => {

                if (data.length > 0) {
                    setListOfRoles(data);
                }
                else {
                    setListOfRoles([]);
                }
            })

        setRoleName('');
        setShowFor('');
        resetHmapValues();

        // Yup Validation setValue
        // setting value for Yup validations
        setValue('roleName', '');

        setEditFlag(false);

    }, [companyName]);


    const accessSpecifierOptions = [{ value: "N/A", label: "N/A" }, { value: "Edit", label: "Edit" }, { value: "View", label: "View" }];


    const handleInputChangeGrid = (e, key) => {
        let new_key = removeSpaces(key.split("_")[0]) + "_" + key.split("_")[1];
        let hmap = { ...grid }
        hmap[new_key] = e;

        setGrid(hmap);
    };

    const resetHmapValues = () => {
        let hmap = { ...grid }
        let keys = Object.keys(hmap);

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            hmap[key] = '';

            let module_name = key.split('_')[0];
            let col_name = key.split('_')[1];

            if (col_name === 'Access Specifier') {
                hmap[key] = accessSpecifierOptions[0]['value'];
            }

        }

        setGrid(hmap);
    }

    const submitHandler = () => {
        setSuccessMsg("");
        setLoading(true);
        setValidationMsg("");

        if (roleName === '') {
            setLoading(false)
            setValidationMsg("Please enter name to proceed...")
            window.scrollTo(0, 0);
            return;
        }
        else {
            let hmap = { ...grid }
            let keys = Object.keys(hmap)
            let finalHmap = {}

            for (let i = 0; i < keys.length; i++) {
                if (hmap[keys[i]] != '') {
                    finalHmap[keys[i]] = hmap[keys[i]];
                }
            }
            let obj1 = {}
            if (editFlag) {
                obj1 = JSON.stringify({
                    "account_id": company_id,
                    "role_id": role_id,
                    "role_name": roleName,
                    "role_definition": finalHmap,
                    "flag": editFlag
                })
            }
            else {
                obj1 = JSON.stringify({
                    "account_id": company_id.toString(),
                    "role_name": roleName,
                    "role_definition": finalHmap,
                    "flag": editFlag
                })
            }
            fetch(baseURL + '/save_srt_roles_setup',
                {
                    method: 'POST',
                    headers: { 'Content-type': 'application/json' },
                    body: obj1
                })
                .then(resp => resp.json())
                .then(data => {
                    setLoading(false)
                    if (data === 'Duplicate Entry') {
                        setValidationMsg('Role Name already exists. Please try again with different Role Name')
                        window.scrollTo(0, 0);
                        return;
                    }
                    else {
                        setSuccessMsg("Roles added/edited successfully")
                        setListOfRoles(data);

                        setRoleName('');
                        setShowFor('');
                        resetHmapValues();

                        // Yup Validation setValue
                        // setting value for Yup validations
                        setValue('roleName', '');

                        setEditFlag(false);
                        window.scrollTo(0, 0);
                    }
                })
                .catch(error => console.log(error))
        }
    }

    const editRole = (i) => {
        Swal.fire({
            title: 'Edit the selected Role?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    setEditFlag(true);
                    setCreateNewFlag(true);

                    listOfRoles.map((arr, index) => {
                        if (i === index) {
                            setRoleName(arr['role_name']);
                            setRole_id(arr['_id'])
                            // Yup Validation setValue
                            // setting value for Yup validations
                            setValue('roleName', arr['role_name']);

                            // setShowFor(arr['show_for']);
                            let tempGrid = arr['role_definition'];
                            let hmap = { ...grid }
                            let keys = Object.keys(hmap);

                            for (let j = 0; j < keys.length; j++) {
                                if (tempGrid[keys[j]] != undefined) {
                                    hmap[keys[j]] = tempGrid[keys[j]];
                                }
                                else {
                                    hmap[keys[j]] = '';
                                }
                            }

                            setGrid(hmap);
                        }
                    })
                }
            })
    }

    return (
        <>
            <div className="row pt-2">
                <div className="col-12 mx-3">
                    <span style={{ color: '#1E1E1E', fontSize: '21px' }}>Give Access Rolewise:</span>
                </div>
            </div>


            <div className="row pt-4 mx-2">
                <div className="col-md-10">
                    {
                        validationMsg ?
                            (<Alert severity="error">{validationMsg}!</Alert>) : ""
                    }

                    {
                        successMsg ?
                            (
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    {successMsg}
                                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setSuccessMsg('')}></button>
                                </div>
                            )
                            : ""
                    }


                </div>
            </div>

            <div className='col-10  mx-3'>
                {/* <div className="row pt-3" >
                    <div className="col-md-2 mb-3">
                        <label htmlFor="company_name" className="form-label" style={{ marginTop: 5, color: '#1E1E1E', fontSize: '16px' }}>
                            Select Account
                        </label>
                    </div>

                    <div className="col-md-4 mb-3">

                        <Select

                            value={{ value: companyName, label: (companyName ? companyName : "Choose Account") }}
                            inputId="company_name"
                            name="company_name"
                            options={companyNameOptions}
                            onChange={handleInputChangeCompanyName}

                        />

                    </div>


                    <div className="col-md-1 mb-3"></div>

                    <div className="col-md-2 mb-3">
                    </div>
                    <div className="col-md-3 mb-3">

                    </div>

                </div> */}
            </div>


            <div className="row pt-2 mx-2">
                <div className="col-md-10">
                    {companyName != "" && (
                        createNewFlag ?
                            (<Button variant="contained" onClick={() => setCreateNewFlag(false)} >- Hide</Button>) :
                            editFlag ? (<Button variant="contained" onClick={() => setCreateNewFlag(true)} >Edit Role</Button>) :
                                (<Button variant="contained" onClick={() => setCreateNewFlag(true)} >+ Create New</Button>)
                    )
                    }
                </div>
            </div>

            {
                createNewFlag ?
                    <>
                        <form className="row g-3" onSubmit={handleSubmit(submitHandler)}>
                            <div className="row pt-4 mx-2">
                                <div className="col-md-10">

                                    <div className="row pt-3">
                                        <div className="col-md-2 mb-1">
                                            <label htmlFor="roleName" className="form-label" style={{ marginTop: 5, color: '#1E1E1E', fontSize: '16px' }}>
                                                Role Name *
                                            </label>
                                        </div>

                                        <div className="col-md-4 mb-1">
                                            <input type="text" disabled={editFlag} className={`form-control ${errors.roleName ? 'is-invalid' : ''}`} {...register('roleName')} id="roleName" value={roleName} onChange={(e) => setRoleName(e.target.value)} />
                                            <div className="invalid-feedback">{errors.roleName?.message}</div>
                                        </div>

                                        <div className="col-md-1 mb-3"></div>

                                        <div className="col-md-2 mb-3">
                                            {/* <label htmlFor="showFor" className="form-label" style={{ marginTop: 5 }}>
                                                Show For
                                            </label> */}
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            {/* <Select
                                                value={{ value: showFor, label: (showFor ? showFor : "Select..") }}
                                                inputId="showFor"
                                                name="showFor"
                                                options={showForOptions}
                                                onChange={handleInputChangeShowFor}
                                                isDisabled={editFlag}
                                            /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="row pt-4">
                                <div className="col-md-6 mb-1 mx-2">
                                    <table className="table table-bordered table-condensed table-hover text-center">
                                        <thead>
                                            <tr>
                                                <th scope="col">Module</th>
                                                <th scope="col">Access Specifier</th>

                                            </tr>
                                        </thead>
                                        <tbody className="text-left">
                                            {/* Dashboard */}
                                            <tr>
                                                <td>{modulesList[0]['name']}</td>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <select class="form-select" aria-label="Default select example" value={grid[removeSpaces(modulesList[0]['name']) + "_" + columnList[0]]} style={{ width: '100%' }} onChange={(e) => handleInputChangeGrid(e.target.value, modulesList[0]['name'] + "_" + columnList[0])}>
                                                        {
                                                            accessSpecifierOptions.map((val) => (
                                                                <option value={val.value}>{val.label}</option>))
                                                        }
                                                    </select>
                                                </td>

                                            </tr>

                                            {/* Account */}
                                            <tr>
                                                <td>{modulesList[1]['name']}</td>
                                                <td> <select class="form-select" aria-label="Default select example" value={grid[removeSpaces(modulesList[1]['name']) + "_" + columnList[0]]} style={{ width: '100%' }} onChange={(e) => handleInputChangeGrid(e.target.value, modulesList[1]['name'] + "_" + columnList[0])}>
                                                    {
                                                        accessSpecifierOptions.map((val) => (
                                                            <option value={val.value}>{val.label}</option>))
                                                    }
                                                </select></td>

                                            </tr>

                                            {/* Account Location */}
                                            <tr>
                                                <td>{modulesList[2]['name']}</td>
                                                <td><select class="form-select" aria-label="Default select example" value={grid[removeSpaces(modulesList[2]['name']) + "_" + columnList[0]]} style={{ width: '100%' }} onChange={(e) => handleInputChangeGrid(e.target.value, modulesList[2]['name'] + "_" + columnList[0])}>
                                                    {
                                                        accessSpecifierOptions.map((val) => (
                                                            <option value={val.value}>{val.label}</option>))
                                                    }
                                                </select></td>

                                            </tr>

                                            {/* User */}
                                            <tr>
                                                <td>{modulesList[3]['name']}</td>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <select class="form-select" aria-label="Default select example" value={grid[removeSpaces(modulesList[3]['name']) + "_" + columnList[0]]} style={{ width: '100%' }} onChange={(e) => handleInputChangeGrid(e.target.value, modulesList[3]['name'] + "_" + columnList[0])}>
                                                        {
                                                            accessSpecifierOptions.map((val) => (
                                                                <option value={val.value}>{val.label}</option>))
                                                        }
                                                    </select>
                                                </td>

                                            </tr>

                                            {/* Location */}
                                            <tr>
                                                <td>{modulesList[4]['name']}</td>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <select class="form-select" aria-label="Default select example" value={grid[removeSpaces(modulesList[4]['name']) + "_" + columnList[0]]} style={{ width: '100%' }} onChange={(e) => handleInputChangeGrid(e.target.value, modulesList[4]['name'] + "_" + columnList[0])}>
                                                        {
                                                            accessSpecifierOptions.map((val) => (
                                                                <option value={val.value}>{val.label}</option>))
                                                        }
                                                    </select>
                                                </td>

                                            </tr>

                                            {/* Tax */}
                                            <tr>
                                                <td>{modulesList[5]['name']}</td>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <select class="form-select" aria-label="Default select example" value={grid[removeSpaces(modulesList[5]['name']) + "_" + columnList[0]]} style={{ width: '100%' }} onChange={(e) => handleInputChangeGrid(e.target.value, modulesList[5]['name'] + "_" + columnList[0])}>
                                                        {
                                                            accessSpecifierOptions.map((val) => (
                                                                <option value={val.value}>{val.label}</option>))
                                                        }
                                                    </select>
                                                </td>

                                            </tr>
                                            {/* Tax */}
                                            <tr>
                                                <td>{modulesList[8]['name']}</td>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <select class="form-select" aria-label="Default select example" value={grid[removeSpaces(modulesList[8]['name']) + "_" + columnList[0]]} style={{ width: '100%' }} onChange={(e) => handleInputChangeGrid(e.target.value, modulesList[8]['name'] + "_" + columnList[0])}>
                                                        {
                                                            accessSpecifierOptions.map((val) => (
                                                                <option value={val.value}>{val.label}</option>))
                                                        }
                                                    </select>
                                                </td>

                                            </tr>
                                            {/* Tax */}
                                            <tr>
                                                <td>{modulesList[10]['name']}</td>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <select class="form-select" aria-label="Default select example" value={grid[removeSpaces(modulesList[10]['name']) + "_" + columnList[0]]} style={{ width: '100%' }} onChange={(e) => handleInputChangeGrid(e.target.value, modulesList[10]['name'] + "_" + columnList[0])}>
                                                        {
                                                            accessSpecifierOptions.map((val) => (
                                                                <option value={val.value}>{val.label}</option>))
                                                        }
                                                    </select>
                                                </td>

                                            </tr>

                                           


                                        </tbody>
                                    </table>
                                </div>
                            </div>


                            <div className="row pt-2 pb-4">
                                <div className="col-md-5"></div>
                                <div className="col-md-4">
                                    {
                                        loading ?
                                            <button className="btn btn-success" type="button" disabled>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 5 }}></span>
                                                Submit
                                            </button> :
                                            <button type='submit' className="btn btn-success" >
                                                Submit
                                            </button>
                                    }
                                </div>
                            </div>
                        </form>
                    </> : ''
            }

            {
                listOfRoles.length > 0 ?
                    <>
                        <div className="row pt-5 mx-2">
                            <h5><strong>Existing Roles</strong></h5>
                        </div>

                        <div className="row pt-4 mx-2">
                            <div className="col-md-6">
                                <table className="table table-bordered table-condensed table-hover text-center">
                                    <thead>
                                        <tr>
                                            <th scope="col">Sr. No.</th>
                                            <th scope="col">Role Name</th>
                                            <th scope="col">Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-left">
                                        {
                                            listOfRoles.map((val, index) => (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{val.role_name}</td>
                                                    <td><button className="btn" onClick={(e) => editRole(index)}><EditIcon /></button></td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </> : ''
            }

        </>
    )
}